import { APPROVAL_GATE_STATES } from "../step-modules/approval-gate";
import type { WorkflowStepRendererProps } from "../types";

function statusCopy(state: string): { title: string; detail: string } {
  switch (state) {
    case "in_review":
      return {
        title: "Human approval is open",
        detail: "Approve or request changes from Review once the draft and its evidence are decision-ready.",
      };
    case "approved":
    case "scheduled":
      return {
        title: "Approved for publish-adjacent work",
        detail: "Use Review to record a publish URL or make an explicit non-publish decision before this drifts out of operator context.",
      };
    case "published":
      return {
        title: "Approval loop is complete",
        detail: "Publishing is recorded. The next operator move is performance follow-up and durable learning capture.",
      };
    default:
      return {
        title: "Approval not open yet",
        detail: "This step appears once voice review passes and the brief reaches human review.",
      };
  }
}

export function ApprovalStepRenderer({
  context,
}: WorkflowStepRendererProps<null>) {
  const copy = statusCopy(context.brief.state);

  if (!APPROVAL_GATE_STATES.includes(context.brief.state)) {
    return null;
  }

  return (
    <div className="rounded-lg border border-sky-200 bg-sky-50 px-3 py-3 text-sm text-sky-950">
      <p className="font-semibold">{copy.title}</p>
      <p className="mt-1 text-xs text-sky-900/80">{copy.detail}</p>
    </div>
  );
}
